<template lang="html">
<div>
  <b-button
    v-if="permission !== 'granted'"
    class="is-danger"
    v-on:click="requestPermission">
    Allow {{ eventType }}
  </b-button>

  <div v-if="debug">
    <ul>
      <li> permission: <code>{{ permission }}</code></li>
      <li> permission type: <code>{{ permissionType }}</code></li>
      <li> start time: <code>{{ starttime }}</code></li>
      <li> app time: <code>{{ (apptime).toFixed(0) }}</code></li>
      <!-- <li> sensor timestamp: <code>{{ timestamp.toFixed(0) }}</code></li> -->
      <li> unix time: <code>{{ unixtime }}</code></li>
      <li> utc time: <code>{{ utcTime }}</code></li>
      <slot name="sensorOutput"></slot>
    </ul>
  </div>
  <BaseError v-bind:errorMsg="errorMsg"></BaseError>
</div>
</template>

<script>
import BaseError from './BaseError.vue'

export default {
  components: {
    BaseError
  },
  props: {
    event: {
      type: Function,
      require: true
    },
    eventType: {
      type: String,
      required: true
    },
    debug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      permission: false,
      permissionType: '',
      starttime: Date(),
      apptime: 0,
      timestamp: 0,
      unixtime: '',
      errorMsg: ''
    }
  },
  computed: {
    utcTime () {
      if (this.unixtime !== '') {
        return new Date(this.unixtime).toISOString()
      } else {
        return ''
      }
    }
  },
  methods: {
    apiAvailable () {
      return typeof (this.event) !== 'undefined'
    },
    requiresPermission () {
      return typeof (
        this.event.requestPermission) === 'function'
    },
    requestPermission () {
      if (this.requiresPermission()) {
        this.permissionType = 'user granted'
        this.event.requestPermission()
          .catch(() => {
            // Show permission dialogue when we don't have permission.
            this.permission = false
          })
          .then(permissionState => {
            this.permission = permissionState
          })
      } else {
        // Assume permission, still may be disabled in browser settings.
        this.permissionType = 'assumed'
        this.permission = 'granted'
      }
    },
    handleMovementEvent (event) {
      this.apptime = event.timeStamp
      // console.log(event.type);
      this.unixtime = Date.now()
      this.$emit(event.type, event)
    }
  },
  watch: {
    permission (perm) {
      if (perm === 'granted') {
        window.addEventListener(
          this.eventType,
          this.handleMovementEvent,
          true // useCapture?
          // MDN example is true,
          // vue-use-web is false
          // https://github.com/Tarektouati/vue-use-web/blob/master/src/DeviceMotion.ts
        )
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.apiAvailable()) {
        this.errorMsg = `${this.eventType} is not available on this device.`
      } else {
        this.requestPermission()
      }
    })
  },
  beforeDestroy () {
    // console.log(`Kill ${ this.eventType }`);
    window.removeEventListener(
      this.eventType,
      this.handleMovementEvent
    )
  }
}
</script>
